<div class="block-contract-rental-objects astral-stack-m">
  <div class="block-contract-rental-objects__toolbar">
    <astral-button variant="primary" size="small" type="button" icon="plus" labelKey="ADD_MORE" (click)="createRow()"></astral-button>
    <astral-checkbox [control]="displayForm.controls['displayHistory']"></astral-checkbox>
  </div>

  <app-list-view
    [columnDefinition]="columns"
    [contextMenuDefinition]="menu"
    [itemsSource]="visibleRows"
    [preferencesKey]="'rent.block-contract.rental-objects.list'"
    (rowClick)="onRowClicked($event)"
  ></app-list-view>
</div>

<ng-template #rentalObjectSidebar>
  @if (selectedRow) {
    <form [formGroup]="selectedRow.form" class="astral-sidebar-shell" (ngSubmit)="confirmEditor()" novalidate>
      <div class="astral-sidebar-content astral-stack-l">
        <header>
          <h2 class="astral-sidebar-heading">{{ 'LEASE_AGREEMENT.RENTAL_OBJECT' | translate }}</h2>
        </header>
        <div class="astral-form-stack">
          <astral-select [control]="selectedRow.form.controls['category']" [itemsSource]="categories"></astral-select>
          <astral-select
            [control]="selectedRow.form.controls['rentalObjectId']"
            [itemsSource]="getObjectSelection(selectedRow.form)"
            [noOptionsPlaceholderText]="'COMMON.NO_OPTIONS_AVAILABLE'"
            [disableWhenNoOptions]="true"
          ></astral-select>
          <astral-layout-group [columns]="2" [tabletColumns]="2" [mobileColumns]="1" [span]="'full'">
            <astral-date-picker [control]="selectedRow.form.controls['fromDate']"></astral-date-picker>
            <astral-date-picker [control]="selectedRow.form.controls['toDate']"></astral-date-picker>
          </astral-layout-group>
        </div>
      </div>
      <footer class="astral-sidebar-footer">
        <astral-button variant="primary" type="submit" labelKey="OK_BTN"></astral-button>
        <astral-button variant="secondary" type="button" labelKey="CANCEL_BTN" (click)="cancelEditor()"></astral-button>
      </footer>
    </form>
  }
</ng-template>
